import { Controller } from 'react-hook-form';
import {
  InputSize,
  InputText,
  Select,
  SelectSize,
  SelectType,
  Textarea,
} from '@ui/src';
import { CustomerWealthTypes } from '../../types';
import StepPartBlock from './step-part-block';
import InfoRow from '../../info-row';
import { NewApplicationStatus } from '../../../../hoc/new-application/types';
import AnnualIncomes from './annual-incomes';

import cn from '../../new-application.module.css';

const CustomerWealth = ({
  questionnarieControl,
  questionnarieClearErrors,
  questionnarieErrors,
  status,
  isEditable,
  questionnarieSetValue,
  questionnarieFields,
  annualIncomes,
  totalIncomeError,
  setTotalIncomeError,
  customerSourceOfWealth,
  baseCurrency,
}: CustomerWealthTypes) => (
  <StepPartBlock title="Customer's wealth" zIndex={13}>
    <InfoRow
      title="Source of the Customer's wealth (total assets)"
      id="sourceOfWealthIds"
      style={{
        position: 'relative',
        zIndex: 8,
      }}
      lessPadding
    >
      <Controller
        control={questionnarieControl}
        name="sourceOfWealthIds"
        defaultValue={[]}
        render={({ field: { onChange, value, name } }) => (
          <Select
            name={name}
            placeholder="Select an option..."
            list={
              customerSourceOfWealth?.map((item) => ({
                name: item.value,
                value: item.id,
              })) || []
            }
            value={value}
            size={SelectSize.SMALL}
            onChange={(e) => {
              onChange(e);
              questionnarieClearErrors(['sourceOfWealthIds']);

              if (
                !(e.target.value as string[])?.includes('Other') &&
                questionnarieFields?.sourceOfWealthOther
              ) {
                questionnarieClearErrors(['sourceOfWealthOther']);
                questionnarieSetValue('sourceOfWealthOther', '');
              }
            }}
            selectWrapperClassName={
              status === NewApplicationStatus.ACCEPTED ||
              status === NewApplicationStatus.DECLINED
                ? cn.selectDisabled
                : ''
            }
            disabled={
              !isEditable ||
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
            }
            tabIndex={
              !isEditable &&
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
                ? -1
                : 0
            }
            error={questionnarieErrors?.sourceOfWealthIds?.message}
            mode={SelectType.MULTIPLE}
            fullWidth
            borderless
          />
        )}
      />
    </InfoRow>
    {questionnarieFields?.sourceOfWealthIds?.find((item) =>
      customerSourceOfWealth
        ?.find((client) => item === client.id)
        ?.value?.includes('Other'),
    ) && (
      <InfoRow
        title="Provide details"
        id="sourceOfWealthOther"
        className={cn.noFlex}
        lessPadding
      >
        <Controller
          control={questionnarieControl}
          name="sourceOfWealthOther"
          defaultValue=""
          render={({ field: { onChange, value, name } }) => (
            <Textarea
              name={name}
              title=""
              placeholder="Enter details..."
              value={value}
              onChange={(e) => {
                onChange(e);
                questionnarieClearErrors(['sourceOfWealthOther']);
              }}
              className={`borderless ${cn.pepTextarea} ${cn.stepOneTextarea}`}
              error={questionnarieErrors?.sourceOfWealthOther?.message}
              tabIndex={
                !isEditable &&
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
                  ? -1
                  : 0
              }
              disabled={
                !isEditable ||
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
              }
            />
          )}
        />
      </InfoRow>
    )}
    <InfoRow
      title={`Estimated total wealth (${baseCurrency?.name})`}
      id="estimatedTotalWealth"
      lessPadding
    >
      <Controller
        control={questionnarieControl}
        name="estimatedTotalWealth"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            placeholder="Enter amount..."
            value={value}
            size={InputSize.SMALL}
            onChange={(e) => {
              onChange(e);
              questionnarieClearErrors(['estimatedTotalWealth']);
            }}
            className="borderless"
            disabled={
              !isEditable ||
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
            }
            tabIndex={
              !isEditable &&
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
                ? -1
                : 0
            }
            error={questionnarieErrors?.estimatedTotalWealth?.message}
            currency={baseCurrency}
            amountInput
          />
        )}
      />
    </InfoRow>
    <InfoRow
      title={`Annual income (${baseCurrency?.name})`}
      id="annualIncome"
      lessPadding
    >
      <Controller
        control={questionnarieControl}
        name="annualIncome"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            placeholder="Enter amount..."
            value={value}
            size={InputSize.SMALL}
            onChange={(e) => {
              onChange(e);
              questionnarieClearErrors(['annualIncome']);
            }}
            className="borderless"
            disabled={
              !isEditable ||
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
            }
            tabIndex={
              !isEditable &&
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
                ? -1
                : 0
            }
            error={questionnarieErrors?.annualIncome?.message}
            currency={baseCurrency}
            amountInput
          />
        )}
      />
    </InfoRow>
    <AnnualIncomes
      questionnarieControl={questionnarieControl}
      questionnarieClearErrors={questionnarieClearErrors}
      questionnarieErrors={questionnarieErrors}
      status={status}
      isEditable={isEditable}
      questionnarieSetValue={questionnarieSetValue}
      questionnarieFields={questionnarieFields}
      annualIncomes={annualIncomes}
      totalIncomeError={totalIncomeError}
      setTotalIncomeError={setTotalIncomeError}
    />
  </StepPartBlock>
);

export default CustomerWealth;
